import React from 'react'
import { Box, Select, MenuItem,TextField} from '@mui/material'
import { DataGrid, GridColumnMenu } from '@mui/x-data-grid';
import borderStyle from '../../styles/borderStyle'

// const firstRow = {
//     Catagery: "",
//     Job_Descrption: "",
//     Start_Time: "",
//     End_Time: "",
//     id: 1,
//     Bay: "",
//     Status: "",
    
// }

// const boxStyle = {
//     root: {
//       backgroundColor: 'white', 
//       borderRadius: '5px',
//       padding: 1
//     },
//   };

  const dataGridStyle = {
    root: {
      "& .MuiDataGrid-root": {
        borderRadius: '10px',
        backgroundColor: 'white',
        fontSize: '15px',
      },
      "& .MuiDataGrid-columnHeaders": {
        color: '#005A9C',
        fontSize: '16px',
      }
    },
  };
  
function CustomColumnMenu(props) {
    return (
      
      <GridColumnMenu
        {...props}
        slots={{
       // Hide `columnMenuColumnsItem`
        columnMenuColumnsItem: null,
        columnMenuSortItem: null,
        }}
      />
      
  );
  }
       



function SpareParts() {
    
    const columns = [
    { field: 'id', headerName: ' NO', editable: false, sortable: false  },
    { field: 'Part_No', headerName: 'Part No', editable: false, sortable: false },
    { field: 'Part_Descrption', headerName: 'Part Descrption', editable: false, sortable: false, flex: 2, minWidth: 100 },
    { field: 'Alloted_Qty', headerName: 'Alloted Qty', editable: false, sortable: false, flex: 1 , minWidth: 100},
    { field: 'Taken_Qty', headerName: 'Taken Qty', editable: false, sortable: false, flex: 1 , minWidth: 100,
    renderCell: (params) => (
      <TextField fullWidth size='small' variant="outlined" required name='Taken Qty' />
  ),},
    { field: 'Return_Qty', headerName: 'Return Qty', editable: false, sortable: false, flex: 1, minWidth: 100,
     renderCell: (params) => (
      <TextField fullWidth size='small' variant="outlined" required name='Return Qty' />
  ), },
    { field: 'Status', headerName: 'Status', editable: false, sortable: false, flex: 1 , minWidth: 100,
    renderCell: (params) => (
        <Select
            fullWidth
            variant="outlined"
            style={borderStyle.root}
            // value={params.row.Status}
            // onChange={(e) => handleFieldChange(e, params.row.id, 'discType')}
            size="small"
        >
            <MenuItem value="1"> Waiting </MenuItem>
            <MenuItem value="2"> Completed </MenuItem>
            <MenuItem value="3"> Fitted </MenuItem>
        </Select>
    )},
    
    ];
    
     
    
    const rows = [
    { id: '1', Part_No: 'B3341', Part_Descrption: 'Oil Filtter Assy', Alloted_Qty: '1',Taken_Qty:'', Return_Qty:'',Status:''},
    { id: '2', Part_No: 'B45093', Part_Descrption: 'Engin Oil', Alloted_Qty: '5',Taken_Qty: '', Return_Qty:'',Status:''},
    { id: '3', Part_No: 'B98756', Part_Descrption: 'Speedometer Cable', Alloted_Qty: '1',Taken_Qty: '', Return_Qty:'',Status:''},
    
    ]; 

    return (
      <form>
        <Box sx={dataGridStyle.root}>
          <DataGrid
            columnHeaderHeight={30}
            rowHeight={30}
            rows={rows}
            columns={columns}
            getRowId={(row) => row.id}
            initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
            pageSizeOptions={[10]}
            slots={{ columnMenu: CustomColumnMenu }}
            disableRowSelectionOnClick
          />
        </Box>
      </form>
    );
}

export default SpareParts